import { createContext, useContext } from "react"

// Carries the current user's accessible-route-paths Set (from
// getAccessibleRoutePaths, computed once in App.js) down to deeply nested
// page components — e.g. ManagerWorkspaceHeader's tab-switcher — without
// those components importing shared/procurement/accessibleRoutes.js
// themselves. That module pulls in routes.js for the routing tables, and
// routes.js itself imports the page containers that render
// ManagerWorkspaceHeader, so a direct import there would be a circular
// dependency (routes.js -> PurchasesContainer -> ManagerWorkspaceHeader ->
// accessibleRoutes.js -> routes.js). Context sidesteps it entirely.
const AccessibleRoutesContext = createContext(null)

export const AccessibleRoutesProvider = ({ paths, children }) => (
  <AccessibleRoutesContext.Provider value={paths}>
    {children}
  </AccessibleRoutesContext.Provider>
)

// Falls back to an empty Set outside the provider (e.g. in tests) so callers
// never need a null check.
const EMPTY_PATHS = new Set()
export const useAccessibleRoutePaths = () => useContext(AccessibleRoutesContext) || EMPTY_PATHS
